import React from "react"

function IconTimesSmall({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="times-small"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-times-small"
      {...props}
    >
      <path
        d="m7.607 6.804.09.076 4.343 4.343 4.344-4.343a.655.655 0 0 1 1.001.835l-.075.09-4.344 4.343 4.344 4.344a.655.655 0 0 1-.835 1.002l-.09-.076-4.345-4.344-4.343 4.344a.655.655 0 0 1-1.001-.835l.076-.09 4.343-4.345-4.343-4.342a.655.655 0 0 1 .835-1.002z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconTimesSmall
